import * as React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export const ChevronUp = (props: SvgIconProps) => {
  return (
    <SvgIcon width={16} height={16} viewBox="0 0 16 16" fill="none" {...props}>
      <path
        fill="currentColor"
        d="M12.8531 10.3531C12.8067 10.3997 12.7515 10.4366 12.6907 10.4618C12.63 10.487 12.5649 10.5 12.4991 10.5C12.4333 10.5 12.3682 10.487 12.3075 10.4618C12.2467 10.4366 12.1916 10.3997 12.1451 10.3531L7.99911 6.20611L3.85311 10.3531C3.75922 10.447 3.63188 10.4997 3.49911 10.4997C3.36633 10.4997 3.23899 10.447 3.14511 10.3531C3.05122 10.2592 2.99848 10.1319 2.99848 9.99911C2.99848 9.86633 3.05122 9.73899 3.14511 9.64511L7.64511 5.14511C7.69155 5.09854 7.74673 5.0616 7.80747 5.03639C7.86822 5.01119 7.93334 4.99821 7.99911 4.99821C8.06487 4.99821 8.12999 5.01119 8.19074 5.03639C8.25148 5.0616 8.30666 5.09854 8.35311 5.14511L12.8531 9.64511C12.8997 9.69155 12.9366 9.74673 12.9618 9.80747C12.987 9.86822 13 9.93334 13 9.99911C13 10.0649 12.987 10.13 12.9618 10.1907C12.9366 10.2515 12.8997 10.3067 12.8531 10.3531Z"
      />
    </SvgIcon>
  );
};
